import { render } from "./SelectableStarRating.vue?vue&type=template&id=2f862650&scoped=true"
import script from "./SelectableStarRating.vue?vue&type=script&lang=js"
export * from "./SelectableStarRating.vue?vue&type=script&lang=js"

import "./SelectableStarRating.vue?vue&type=style&index=0&id=2f862650&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f862650"]])

export default __exports__